import { render, staticRenderFns } from "./SaiCard.vue?vue&type=template&id=4e02bfac&scoped=true"
import script from "./SaiCard.vue?vue&type=script&lang=js"
export * from "./SaiCard.vue?vue&type=script&lang=js"
import style0 from "./SaiCard.vue?vue&type=style&index=0&id=4e02bfac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02bfac",
  null
  
)

export default component.exports